import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  HomeEduCenter,
  RiskTypeLinks,
  Link,
  LinkIcon
} from '../../components'
import Styles from './EduCenterHome.css'

@CSSModules(Styles, {allowMultiple:true})
export default class EduCenterHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Action center',
      description: 'Learn how to work with your employer to ensure your retirement plan is sustainably invested.',
      url: config.domain + config.routes.EduCenterHome
    }
  }

  render() {
    const fffIcon = require( '../../../static/images/icons/fff-icn-clr.png' )
    const dffIcon = require( '../../../static/images/icons/dff-icn-clr.png' )
    const gefIcon = require( '../../../static/images/icons/gef-icn-clr.png' )
    const gffIcon = require( '../../../static/images/icons/gff-icn-clr.png' )
    const pffIcon = require( '../../../static/images/icons/pff-icn-clr.png' )
    const wffIcon = require( '../../../static/images/icons/wff-icn-clr.png' )
    const tffIcon = require( '../../../static/images/icons/tff-icn-clr.png' )
    const fossilFuelsChart = require( '../../../static/images/fossil-fuels-chart.png' )
    const vinixOwns = require( '../../../static/images/vinix-owns.jpg' )
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <h1 styleName='large-page-title'>
            Action center
          </h1>
          <h2 styleName='subtitle'>
            Learn how to work with your employer to ensure your retirement
            plan is sustainably invested.
          </h2>
        </ContainerDivs>
        <HomeEduCenter noheader/>
        <br/>
        <br/>
        <ContainerDivs>
          <div styleName='answer'>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                You have the power to create an economy rooted in justice and sustainability
              </h2>
              <div styleName='answer-info'>
                <p>
                  We now stand in a critical moment in history where we have already heated the globe by 1ºC, and at current emissions rates, we will hit the 1.5ºC level deemed safe by scientists in less than a decade. You have the power to help shift trillions of dollars away from climate destruction and into companies that create a new safe, just, and sustainable world.
                </p>
                <p>
                  If you care about the environment and also want to address social inequities in this country, you are not alone. <Link to='https://engageforgood.com/stats/' title='(Even More) Social Impact Statistics You Should Know - Engage for Good' xstrong>Two-thirds of adult Americans</Link> say that addressing climate change and doing more to protect our environment should be a top priority for our president and for congress. Just over seventy percent believe that companies have more responsibility than ever before to address social justice issues. Unfortunately, if you participate in an employee-sponsored retirement plan in the U.S., you may be helping finance these problems unknowingly.
                </p>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                Retirement plans by the numbers
              </h2>
              <div styleName='answer-info'>
                <ul>
                  <li>
                    <Link to='https://www.bls.gov/opub/ted/2021/67-percent-of-private-industry-workers-had-access-to-retirement-plans-in-2020.htm' title='67 percent of private industry workers had access to retirement plans in 2020 - U.S. Bureau of Labor Statistics' xstrong>64% of private industry workers</Link> have access to a defined contribution retirement plan like a 401(k)
                  </li>
                  <li>
                    <Link to='https://www.gao.gov/products/gao-21-25' title='Defined Contribution Plans: Federal Guidance Could Help Mitigate Cybersecurity Risks in 401(k) and Other Retirement Plans - U.S. Governement Accountability Office' xstrong>Over 100 million people</Link> participate in employer-sponsored retirement plans
                  </li>
                  <li>
                    401(k)s and other employer-sponsored retirement plans have <Link to='https://www.ici.org/statistical-report/ret_21_q1' title='Retirement Assets Total $35.4 Trillion in First Quarter 2021 - Investment Company Institute' xstrong>$10 trillion invested</Link>
                  </li>
                </ul>
                <p>
                  For most employees, once you have elected your retirement plan options, it is time to sit back and watch your money grow until retirement. Retirement plans often use mutual funds as the plan investment options - 66% of 401(k) assets <Link to='https://www.ici.org/faqs/faq/401k/faqs_401k' title='Frequently Asked Questions About 401(k) Plan Research - Investment Company Institute' xstrong>are in mutual funds.</Link> But those funds can invest in a wide array of securities, and it is not always easy to investigate what’s inside. Most people would not choose to invest in the destruction of the Amazon rainforest, or to profit from climate change, but they unknowingly do.
                </p>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                The environmental impacts
              </h2>
              <div styleName='answer-info'>
                <p>
                  Retirement plans are heavily invested in companies with climate-harming business models that are not aligned with the Paris Climate Agreement.
                </p>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={fffIcon} alt='Fossil fuels' />
                  <div styleName='icon-text-text'>
                    <b>Fossil fuels</b> -  Coal, oil, and gas release carbon pollution that accelerates the climate emergency.
                  </div>
                </div>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={dffIcon} alt='Deforestation' />
                  <div styleName='icon-text-text'>
                    <b>Deforestation</b> - Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.
                  </div>
                </div>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                The social impacts
              </h2>
              <div styleName='answer-info'>
                <p>
                  The social impacts of the companies invested in by retirement plans can include racial and gender injustice, gun violence, and state violence.
                </p>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={gefIcon} alt='Gender equality' />
                  <div styleName='icon-text-text'>
                    <b>Gender equality</b> - Collecting data and scoring companies on gender equality is the first step towards sustainable change.
                  </div>
                </div>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={gffIcon} alt='Civilian firearms' />
                  <div styleName='icon-text-text'>
                    <b>Civilian firearms</b> - Retirement plans are investing in firearm manufacturers and retailers who generate billions of dollars from handgun, assault rifle, and ammunition sales.
                  </div>
                </div>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={pffIcon} alt='Prison industrial complex' />
                  <div styleName='icon-text-text'>
                    <b>Prison industrial complex</b> - Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.
                  </div>
                </div>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={wffIcon} alt='Military weapons' />
                  <div styleName='icon-text-text'>
                    <b>Arms manufacturers and military contractors</b> - Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression
                  </div>
                </div>
                <div styleName='icon-text-flex'>
                  <img styleName='icon-text-icon' src={tffIcon} alt='Tobacco' />
                  <div styleName='icon-text-text'>
                    <b>Tobacco</b> - Most smokers start before they’re 18. Every day, more than 2,000 young Americans become daily smokers.
                  </div>
                </div>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                An example: Vanguard Institutional Index (VINIX)
              </h2>
              <div styleName='answer-info'>
                <p>
                  Let’s say you are looking at your retirement investment options and you see that you own the Vanguard Institutional Index (VINIX) fund, which happens to be one of the most commonly held fund in retirement plans in the U.S. What companies is VINIX investing in? The fund portfolio includes <Link to='https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Fossil Free Funds' xstrong>oil majors</Link> ExxonMobil and Chevron; <Link to='https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Fossil Free Funds' xstrong>coal-fired utilities</Link> Southern Company and Duke Energy; <Link to='https://deforestationfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/profile/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Deforestation Free Funds' xstrong>agribusiness giant</Link> Archer-Daniels Midland, tied to allegations of deforestation and land-grabbing; <Link to='https://weaponfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/weapon-investments/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Weapon Free Funds' xstrong>arms manufacturers</Link> Raytheon Technologies and Lockheed Martin; as well as companies profiting from the <Link to='https://prisonfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/prison-industrial-complex-investments/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Prison Free Funds' xstrong>prison industrial complex</Link>, <Link to='https://gunfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/gun-investments/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Gun Free Funds' xstrong>gun violence</Link>, <Link to='https://tobaccofreefunds.org/fund/vanguard-institutional-index-fund/VINIX/tobacco-profile/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Tobacco Free Funds' xstrong>tobacco</Link>, and <Link to='https://genderequalityfunds.org/fund/vanguard-institutional-index-fund/VINIX/gender-lens-score/FSUSA002Q0/FOUSA00FR3'title='Vanguard Institutional Index Fund - Gender Equality Funds' xstrong>gender inequality</Link>.
                </p>
                <p>
                  VINIX has 6.7% invested in fossil fuels. Let’s say that your 401(k) balance is $100,000, and it’s all invested in VINIX. In this example, that would translate to $6,740 in fossil fuel companies, with $1,240 invested just in ExxonMobil and Chevron.
                </p>
                <p>
                  <Link
                   to='https://fossilfreefunds.org/fund/vanguard-institutional-index-fund/VINIX/fossil-fuel-investments/FSUSA002Q0/FOUSA00FR3'
                   title='Vanguard Institutional Index Fund - Fossil Free Funds'
                   xstrong
                  >
                    See more about VINIX<LinkIcon />
                  </Link>
                </p>
                <p>
                  <img
                    src={vinixOwns}
                    alt='VINIX is invested in fosil fuel companies, arms manufacturers, and other environmentally and socially unsustainable industries'
                    styleName='vinix-owns-chart'
                  />
                </p>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                “I don’t want to profit from climate change and social inequities, but I am not willing to sacrifice returns”
              </h2>
              <div styleName='answer-info'>
                <p>
                  Most people say they want to be able to invest in environmentally and socially responsible companies, but are not willing to sacrifice returns to do so. Planning for retirement is first and foremost about setting yourself up for financial security.
                </p>
                <p>
                  There is a widespread myth that investing sustainably means sacrificing returns. But if anything, the evidence suggests the opposite is true. The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices <Link to={config.routes.eduCenterFinRisks} title='Financial risks of unsustainable investments' xstrong>can destroy shareholder value.</Link>
                </p>
                <p>
                  <Link to='https://www.ussif.org/performance' title='Financial Performance with Sustainable Investing - US-SIF' xstrong>A large body of research indicates</Link> that sustainable investing can provide returns in line with their traditional counterparts, with less risk. The material risks associated with unsustainable business models are sharply highlighted by the performance of the fossil fuel sector over the past decade. <Link to='https://ieefa.org/wp-content/uploads/2019/02/Divestment-Brief-February-2019.pdf' title='Fossil Fuel Investments: Looking Backwards May Prove Costly to Investors in Today’s Market - IEEFA' xstrong>The oil and gas sector of the S&P 500 has placed dead last in returns for the past decade.</Link> In 1980 the oil and gas industry represented 29% of the S&P 500, while today that number has fallen to only 5.3%, marking the lowest level in over 40 years.
                </p>
                <p>
                  <Link
                    to={config.domain + '/images/fossil-fuels-chart.png'}
                    title='Fossil fuel stocks tumble amid a strong overall market'
                  >

                    <img
                      src={fossilFuelsChart}
                      alt='Fossil fuel stocks tumble amid a strong overall market'
                      styleName='fossil-fuel-chart'
                    />
                  </Link>
                </p>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <section>
              <h2 styleName='answer-title'>
                The rise of ESG investing
              </h2>
              <div styleName='answer-info'>
                <p>
                  ESG, or Environmental, Social, and Governance, is an umbrella term for investing in funds that seeks both positive financial returns and long-term positive impacts. Across the world, employees are already seeing that climate change, gender inequality, rainforest destruction, and weapons are destroying their future. Most would not choose to invest in or profit from that destruction. It is clear that people are eager to become a part of the solution. In fact, <Link to='https://www.nytimes.com/2019/09/27/business/esg-401k-investing-retirement.html' title='Bit by Bit, Socially Conscious Investors Are Influencing 401(k)’s - New York Times' xstrong>67 percent of millennials</Link> would be more likely to contribute, or increase their plan contributions, if they knew their investments were contributing to social good.
                </p>
                <p>
                  Investors have not just taken notice of the financial decline in fossil fuel investments, they have begun divesting from fossil fuels. Assets committed to divestment have leapt from $52 billion in 2014 to more than $11 trillion today — a stunning increase of 22,000 percent. <Link to='https://350.org/press-release/global-fossil-fuel-divestment-11t/' title='Global Fossil Fuel Divestment and Clean Energy Investment Movement Crosses $11 Trillion Milestone' xstrong>Over 1,110 institutions</Link> have now committed to policies black-listing coal, oil and gas.
                </p>
                <p>
                  These include sovereign wealth funds, banks, global asset managers and insurance companies, cities, pension funds, health care organizations, universities, faith groups and foundations.
                </p>
                <p>
                  In 2020, the demand for ESG investment options reached a new high. One of the world’s largest investment advisors, BlackRock, released a <Link to='https://www.blackrock.com/corporate/about-us/blackrock-sustainability-survey' title='' xstrong>2020 survey that highlights this trend:</Link>
                </p>
                <ul>
                  <li>
                    When comparing focus on ESG factors, 88% of global respondents ranked Environment as the priority most in focus amongst those choices today, reflecting the urgency that is present by climate change.
                  </li>
                  <li>
                    ESG integration and Exclusionary Screens (the process of screening out specific assets-like fossil fuels) are the two most popular approaches to sustainable investing globally, with 75% and 65% of global respondents, respectively, currently utilizing of considering utilizing these approaches.
                  </li>
                </ul>
              </div>
            </section>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            <h2 styleName='answer-title'>
              Steps and tools to align your investments with your values
            </h2>
            <div styleName='answer-info'>
              <p>
                No matter where you are on your journey to aligning your investments with your values, we have collected the resources to help get you started. These resources are meant for people of all levels of financial expertise. Not only will help you understand what your part in the retirement system, but they will also guide you through the steps to investing your values. Let’s get started.
              </p>
            </div>
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
          </div>
        </ContainerDivs>
        <HomeEduCenter />
        <RiskTypeLinks />
      </div>
    )
  }
}
